import React from 'react';

const A4Page = ({ children }) => {
  return <div className="a4-page border-r-8">{children}</div>;
};

export default A4Page;
